enum SpecialCategoryName {
  Tried = 'Tried',
  Hottest = 'Hottest',
  FriendRecommend = 'Friend Recommend',
  MemberItem = 'Member Reward'
}

export default SpecialCategoryName
